import React from "react";
import { NotImplemented } from "pages/PayRoll/Shared/NotImplemented";

// Placeholder until Bonus is built. Reached from
// Payroll > Pay Inputs > Bonus in the sidebar flyout.
export const PayInputBonus = () => <NotImplemented title="Bonus" />;
